import { default as domainWorkTimeDate } from './date/services' 

export default { 
	domainWorkTimeDate 
}
